var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22135 0.833008C3.54135 0.833008 0.554688 3.81967 0.554688 7.49967C0.554688 11.1797 3.54135 14.1663 7.22135 14.1663C10.9014 14.1663 13.888 11.1797 13.888 7.49967C13.888 3.81967 10.9014 0.833008 7.22135 0.833008ZM7.88802 12.1663H6.55469V10.833H7.88802V12.1663ZM9.26802 6.99967L8.66802 7.61301C8.18802 8.09967 7.88802 8.49967 7.88802 9.49967H6.55469V9.16634C6.55469 8.43301 6.85469 7.76634 7.33469 7.27967L8.16135 6.43967C8.40802 6.19967 8.55469 5.86634 8.55469 5.49967C8.55469 4.76634 7.95469 4.16634 7.22135 4.16634C6.48802 4.16634 5.88802 4.76634 5.88802 5.49967H4.55469C4.55469 4.02634 5.74802 2.83301 7.22135 2.83301C8.69469 2.83301 9.88802 4.02634 9.88802 5.49967C9.88802 6.08634 9.64802 6.61967 9.26802 6.99967Z",
    fill: "#1B51A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHelp);
export default __webpack_public_path__ + "static/media/new_help.1800f995b0db845e56cd753c61a19388.svg";
export { ForwardRef as ReactComponent };